import React from "react";
import {
  AccreditationCard,
  AccreditationSection,
  AccreditationTitle,
  ContentGrid,
  ContentSection,
  CopyPanel,
  CredentialWrapper,
  HealthAndSafetyCreditations,
  HealthPageWrapper,
  HeroInner,
  HeroKicker,
  HeroOverlay,
  HeroSection,
  HeroSubtitle,
  HeroTitle,
  IntroSection,
  IntroText,
  PledgeSection,
  PledgeText,
  PledgeTitle,
  SafetyImage,
  SafetyImagePanel,
  SafetyItem,
  SafetyList,
  SectionText,
  SectionTitle,
} from "./Health_and_SafetyPage.styles";

const HealthAndSafetyPage = ({ backgroundimage }) => {
  const safetyCommitments = [
    "Qualified operators and regular refresher training for all plant and machinery.",
    "Strict PPE standards and clear exclusion zones to protect crews and visitors.",
    "Consistent reporting, auditing, and corrective action tracking across sites.",
  ];

  return (
    <>
      <HealthPageWrapper>
        <HeroSection>
          <HeroOverlay backgroundimage={backgroundimage}>
            <HeroInner>
              <HeroKicker>Our standard on every site</HeroKicker>
              <HeroTitle>Health and Safety</HeroTitle>
              <HeroSubtitle>We plan carefully, operate responsibly, and never compromise on safe working practices.</HeroSubtitle>
            </HeroInner>
          </HeroOverlay>
        </HeroSection>

        <IntroSection>
          <IntroText>At Inert Recycling, health and safety are at the core of everything we do. Our commitment to a safe working environment supports our team, our customers, and the communities where we operate.</IntroText>
        </IntroSection>

        <ContentSection>
          <ContentGrid>
            <CopyPanel>
              <SectionTitle>How we keep standards high</SectionTitle>
              <SectionText>From handling inert materials to operating heavy machinery, we follow disciplined procedures that reduce risk and improve reliability on every job.</SectionText>
              <SafetyList>
                {safetyCommitments.map((item) => (
                  <SafetyItem key={item}>{item}</SafetyItem>
                ))}
              </SafetyList>
            </CopyPanel>
            <SafetyImagePanel>
              <SafetyImage />
            </SafetyImagePanel>
          </ContentGrid>
        </ContentSection>

        <PledgeSection>
          <PledgeTitle>Staying safe on sites across the South of England</PledgeTitle>
          <PledgeText>Regular audits, risk reviews, and continuous improvement help us identify and mitigate issues early. Every team member is encouraged to communicate openly and report potential hazards without delay.</PledgeText>
        </PledgeSection>

        <AccreditationSection>
          <AccreditationTitle>Health and Safety Accreditations</AccreditationTitle>
          <CredentialWrapper>
            <AccreditationCard>
              <HealthAndSafetyCreditations src="https://www.safetypassports.co.uk/wp-content/uploads/2013/02/cropped-SPA-Banner-Logo.png" alt="SPA accreditation" />
            </AccreditationCard>
            <AccreditationCard>
              <HealthAndSafetyCreditations src="https://cdn-res.keymedia.com/cms/images/us/069/0343_638477691031814524.png" alt="ISO accreditation" />
            </AccreditationCard>
            <AccreditationCard>
              <HealthAndSafetyCreditations src="https://i.imgur.com/L7Kjt4T.png" alt="SSIP accreditation" />
            </AccreditationCard>
          </CredentialWrapper>
        </AccreditationSection>
      </HealthPageWrapper>
    </>
  );
};

export default HealthAndSafetyPage;
